import { AbstractQuery } from 'src/models/query';

export class GetTheDetailsForTheDocumentQuery extends AbstractQuery {
	apiVersion = 2;
	name = 'IFS_Desktop_Query_Queries_Document_GetTheDetailsForTheDocumentQuery';
	sort = [];

	constructor(aggregateId: string) {
		super();
		this.parameters.push({ aggregateId: aggregateId });
	}
}

export class GetThePreviewForTheDocumentQuery extends AbstractQuery {
	name = 'IFS_Desktop_Query_Queries_Document_GetThePreviewForTheDocumentQuery';
	sort = [];

	constructor(aggregateId: string, version: string) {
		super();
		this.parameters.push({ aggregateId: aggregateId });
		this.parameters.push({ version: version });
	}
}

export class GetTheTheDocumentQuery extends AbstractQuery {
	name = 'IFS_Desktop_Query_Queries_Document_GetTheTheDocumentQuery';
	sort = [];

	constructor(aggregateId: string) {
		super();
		this.parameters.push({ aggregateId: aggregateId });
	}
}

export class GetTheTheDocumentVersionQuery extends AbstractQuery {
	name = 'IFS_Desktop_Query_Queries_Document_GetTheTheDocumentQuery';
	sort = [];

	constructor(aggregateId: string, version: string) {
		super();
		this.parameters.push({ aggregateId: aggregateId });
		this.parameters.push({ version: version });
	}
}
